import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClinicalDashboardComponent } from './components/clinical-dashboard/clinical-dashboard.component';
import {SpringBoardModule} from "@wuitk/angular/components/springboard";
import {LayoutModule} from "@ispm/layout/layout.module";
import {TestModule} from "@ispm/test/test.module";
import {LayoutEngineModule} from "@ispm-client/modules/layout-engine";
import {SharedModule} from "@ispm/shared/shared.module";
import {UserModule} from "@ispm/user/user.module";
import {EnrolledTestsComponent} from "./components/enrolled-tests/enrolled-tests.component";
import {DynamicFormModule} from '@ispm/shared/dynamic-form/dynamic-form.module';
import {ClinicalTrendsComponent} from './components/clinical-trends/clinical-trends.component';
import {StoreModule} from "@ngrx/store";
import {EffectsModule} from "@ngrx/effects";
import {clinicalDashboardReducer} from "@ispm-client/modules/clinical-dashboard/store/reducers/clinicaldashboard.reducer";
import {ClinicalDashboardEffects} from "@ispm-client/modules/clinical-dashboard/store/actions/clinicalDashboard.effects";
import { ClinicalTrendsListComponent } from './components/clinical-trends/clinical-trends-list/clinical-trends-list.component';
import {CommonModule as DlsCommon} from "@wuitk/angular/components/common";
import { CheckBoxModule } from '@wuitk/angular/components/checkbox';
import { ClinicalTrendsGraphComponent } from './components/clinical-trends/clinical-trends-graph/clinical-trends-graph.component';
import { ToggleButtonModule } from '@wuitk/angular/components/togglebutton';
import {FormsModule} from "@angular/forms";
import { ClinicalTrendsFilterComponent } from './components/clinical-trends/clinical-trends-filter/clinical-trends-filter.component';
import {CalendarModule} from 'primeng/calendar';
import {ClinicalDashboardService} from "@ispm-client/modules/clinical-dashboard/services/clinical-dashboard.service";
import {ButtonModule} from "@wuitk/angular/components/button";
import {RouterModule} from "@angular/router";

@NgModule({
    declarations: [ClinicalDashboardComponent, EnrolledTestsComponent, ClinicalTrendsComponent, ClinicalTrendsListComponent, ClinicalTrendsGraphComponent, ClinicalTrendsFilterComponent],
    imports: [
        CommonModule,
        SharedModule,
        SpringBoardModule,
        LayoutModule,
        LayoutEngineModule,
        TestModule,
        UserModule,
        DynamicFormModule,
    RouterModule.forRoot([]),
        StoreModule.forFeature('clinicalDashboard', clinicalDashboardReducer),
        EffectsModule.forFeature([ClinicalDashboardEffects]),
        DlsCommon,
        CheckBoxModule,
        ToggleButtonModule,
        ButtonModule,
        FormsModule,
        CalendarModule
    ],
    providers: [ClinicalDashboardService],
    entryComponents:[EnrolledTestsComponent]
})
export class ClinicalDashboardModule { }
